import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withSelectorGrid } from "./withSelectorGrid"
import ImageCTA from "../../Image/ImageCTA"

const Wrapper = styled.div<WrapperProps>`
  ${tw`w-full max-w-45 flex flex-wrap text-14 md:text-18 leading-1 mb-1-6 md:mb-2`}
  ${({ inline }) => (inline ? tw`mb-0-4 -mt-0-4 md:mb-1 md:-mt-1 justify-center` : null)}
`
const VariantWrapper = styled.div<VariantWrapperProps>`
  ${tw`flex items-center relative mr-0-2 mb-0-6`}
  ${({ inline }) => (inline ? tw`flex mr-0-4` : null)}
  &:hover .tooltiptext {
    visibility: visible;
  }
`
// ${tw`relative mr-0-6 mb-1-6`} changes here
const MoreColours = styled(Link)``
const VariantWrapperInner = styled.div<VariantWrapperInnerProps>`
  ${tw`rounded-full border border-transparent hover:border-dark`}
  ${({ size }) => (size == "smallSelector" ? tw`p-0-2 ` : tw`p-0-6`)}
  ${({ selected }) => (selected ? tw`border-dark` : null)}
  ${({ inline }) => (inline ? tw`p-0-4` : null)}
`
const Variant = styled.div<VariantProps>`
  ${tw`rounded-full flex flex-col items-center justify-center focus:outline-none overflow-hidden`}
  ${({ size }) => (size == "smallSelector" ? tw`h-1-6 w-1-6 ` : tw`h-3-2 w-3-2 md:h-4 md:w-4`)}
  ${({ available }) => (available ? tw`text-dark bg-transparent` : tw`text-grey bg-beige`)}
  ${({ selected }) => (selected ? tw`bg-beige text-grey` : null)}
  ${({ inline }) => (inline ? tw`h-2 w-2 md:h-3 md:w-3` : null)}
`
const Tooltip = styled.span`
  visibility: hidden;
  width: auto;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  top: 110%;
  left: 50%;
  white-space: nowrap;
  // margin-left: -30px;
  transform: translateX(-50%);
  -ms-transform: translateX(-50%);

  &::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    // margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
  }
`

const SelectorGrid = withSelectorGrid(({ size, variants, selectedVariant, product, colours, selectedProduct, handleChange, getSwatch, inline }) => {
  return (
    <Wrapper inline={inline}>
      {colours.length
        ? colours.map((product, index) =>
            size == "smallSelector" ? (
              <VariantWrapper key={product?.id} inline={inline}>
                {index < 4 ? (
                  <>
                    <VariantWrapperInner size={size} selected={product?.id === selectedProduct} inline={inline}>
                      <Variant size={size} as={Link} selected={product?.id === selectedProduct} to={`/products/${product?.handle}`} inline={inline}>
                        <ImageCTA image={getSwatch(product)?.image || product?.image} />
                      </Variant>
                    </VariantWrapperInner>
                    <Tooltip className={`tooltiptext`}>{product?.tags?.find(tag => tag.includes("colour:"))?.replace("colour:", "")}</Tooltip>
                  </>
                ) : index == 4 ? (
                  <MoreColours
                    className="hover:underline"
                    selected={product?.id === selectedProduct}
                    to={`/products/${product?.handle}`}
                    inline={inline}
                  >
                    + {colours.length - 4} Colours
                  </MoreColours>
                ) : null}
              </VariantWrapper>
            ) : (
              <VariantWrapper key={product?.id} inline={inline}>
                <VariantWrapperInner size={size} selected={product?.id === selectedProduct} inline={inline}>
                  <Variant size={size} as={Link} selected={product?.id === selectedProduct} to={`/products/${product?.handle}`} inline={inline}>
                    <ImageCTA image={getSwatch(product)?.image || product?.image} />
                  </Variant>
                </VariantWrapperInner>
                <Tooltip className={`tooltiptext`}>{product?.tags?.find(tag => tag.includes("colour:"))?.replace("colour:", "")}</Tooltip>
              </VariantWrapper>
            )
          )
        : variants.map(variant => (
            <VariantWrapper key={variant.id} inline={inline}>
              <VariantWrapperInner selected={selectedVariant?.id === variant.id} inline={inline}>
                <Variant
                  size={size}
                  available={variant?.availableForSale}
                  selected={selectedVariant?.id === variant.id}
                  onClick={() => handleChange(variant)}
                  inline={inline}
                >
                  <ImageCTA image={getSwatch(product)?.image || variant?.image?.src} />
                </Variant>
              </VariantWrapperInner>
              <Tooltip className={`tooltiptext`}>
                {variant.selectedOptions?.find(option => option.name.toLowerCase() === "color" || option.name.toLowerCase() === "colour")?.value}
              </Tooltip>
            </VariantWrapper>
          ))}
    </Wrapper>
  )
})

export default SelectorGrid

type WrapperProps = {
  inline: boolean
}

type VariantWrapperProps = {
  inline: boolean
}

type VariantWrapperInnerProps = {
  inline: boolean
  selected: boolean
}

type VariantProps = {
  inline: boolean
  selected: boolean
  available?: boolean
}
